import axios from 'axios';
import { URLS } from '../../utils/url';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const state = {
  categoryTimeprices: [],
  timeprices_clinic: [],
  other_timeprices: [],
  permalinkData: null,
  therapists: [],
  currentCustomer: null,
  clinic: null,
  clinic_name: null,
  timepriceOptions: [],
  timepriceTherapists: [],
  selectedTimeprice: null,
  selectedTimepriceOptions: [],
  selectedTherapist: null,
  customerData: {},
  event: {}
};

const mutations = {
  SET_CATEGORY_TIMEPRICES(state, payload) {
    state.categoryTimeprices = payload;
  },
  SET_PERMALINK_DATA(state, payload) {
    state.permalinkData = payload;
  },
  SET_THERAPISTS(state, payload) {
    state.therapists = payload;
  },
  SET_CURRENT_CUSTOMER(state, payload) {
    state.currentCustomer = payload;
  },
  SET_CLINIC(state, payload) {
    state.clinic = payload;
  },
  SET_CLINIC_NAME(state, payload) {
    state.clinic_name = payload;
  },
  SET_TIMEPRICES_CLINIC(state, payload) {
    state.timeprices_clinic = payload;
  },
  SET_OTHER_TIMEPRICES(state, payload) {
    state.other_timeprices = payload;
  },
  SET_TIMEPRICE_OPTIONS(state, payload) {
    state.timepriceOptions = payload;
  },
  SET_TIMEPRICE_THERAPISTS(state, payload) {
    state.timepriceTherapists = payload;
  },
  SET_SELECTED_TIMEPRICE(state, payload) {
    state.selectedTimeprice = payload;
  },
  SET_SELECTED_TIMEPRICE_OPTIONS(state, payload) {
    state.selectedTimepriceOptions = payload;
  },
  SET_SELECTED_THERAPIST(state, therapist) {
    state.selectedTherapist = therapist;
  },
  SET_CUSTOMER_DATA(state, customerData) {
    state.customerData = customerData;
  },
  SET_EVENT(state, payload) {
    state.event = payload;
  },
  CLEAR_PASSWORD_FIELDS(state) {
    state.customerData.password = '';
    state.customerData.password_confirmation = '';
  }
};

const actions = {
  async fetchPermalinkData({ commit }, permalink) {
    try {
      const response = await axios.get(`/api/v1/permalink/${permalink}`);
      if (response.data) {
        commit('SET_PERMALINK_DATA', response.data);
        commit('SET_CATEGORY_TIMEPRICES', response.data.category_timeprices);
        commit('SET_THERAPISTS', response.data.therapists);
        commit('SET_CURRENT_CUSTOMER', response.data.currentCustomer);
        commit('SET_CLINIC', response.data.clinic);
        commit('SET_CLINIC_NAME', response.data.clinic_name);
        commit('SET_TIMEPRICES_CLINIC', response.data.timeprices_clinic);
        commit('SET_OTHER_TIMEPRICES', response.data.other_timeprices);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      toastr.error('Error fetching data.');
    }
  },
  async fetchTimepriceData({ commit }, timepriceId) {
    try {
      const response = await axios.get(`/api/v1/permalink/get_data_timeprice/${timepriceId}`);
      if (response.data) {
        commit('SET_TIMEPRICE_OPTIONS', response.data.timeprice_options);
        commit('SET_TIMEPRICE_THERAPISTS', response.data.timeprice_therapists);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      toastr.error('Error fetching timeprice options.');
    }
  },
  setSelectedTimeprice({ commit }, timeprice) {
    commit('SET_SELECTED_TIMEPRICE', timeprice);
  },
  setSelectedTimepriceOptions({ commit }, options) {
    commit('SET_SELECTED_TIMEPRICE_OPTIONS', options);
  },
  setSelectedTherapist({ commit }, therapist) {
    commit('SET_SELECTED_THERAPIST', therapist);
  },
  setCustomerData({ commit }, customerData) {
    commit('SET_CUSTOMER_DATA', customerData);
  },
  setTimepriceOptions({ commit }, options) {
    commit('SET_TIMEPRICE_OPTIONS', options);
  },
  addEvent({ commit }, event)  {
    commit('SET_EVENT', event);
  },
  async createBooking({ commit }, payload) {
    $.ajax({
      url: '/room_bookings',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      type: 'post',
      data: payload,
      success: function(res) {
        window.location.href = `/booking_complete/${payload?.permalink}`;
      },
      error: function (res) {
        let responseJson = jQuery.parseJSON(res.responseText);
        toastr.error(responseJson.message);
      }
    });
  },
  clearPasswordFields({ commit }) {
    commit('CLEAR_PASSWORD_FIELDS');
  }
};

const getters = {
  categoryTimeprices: state => state.categoryTimeprices,
  permalinkData: state => state.permalinkData,
  therapists: state => state.therapists,
  currentCustomer: state => state.currentCustomer,
  clinic: state => state.clinic,
  clinicName: state => state.clinic_name,
  timeprices_clinic: state => state.timeprices_clinic,
  otherTimeprices: state => state.other_timeprices,
  timepriceOptions: state => state.timepriceOptions,
  timepriceTherapists: state => state.timepriceTherapists,
  selectedTimeprice: state => state.selectedTimeprice,
  selectedTimepriceOptions: state => state.selectedTimepriceOptions,
  selectedTherapist: state => state.selectedTherapist,
  customerData: state => state.customerData,
  selectedEvent: state => state.event,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
